$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

$(document).ready(function () {

  //Start feedback message popup
  $ ( ".feedback_message_popup .popup_block" ).on ( "click" , function ( e ) {
    e.stopPropagation ();
  } );

  $ ( ".feedback_message_popup .close, .feedback_message_popup " ).on ( "click" , function ( e ) {
    e.preventDefault ();
    $ ( ".feedback_message_popup" ).fadeOut ( function () {
      $ ( "body" ).css ( "overflow" , "auto" );
    } );
  } );

  //End feedback message popup


  $('.lang').on('click', function () {
    $('.drop_lang').toggle();
  });

  if (window.location.pathname == '/' ||
    window.location.pathname == '/en' ||
    window.location.pathname == '/ru' ||
    window.location.pathname == '/am')
    resumeSlide();

  $('#inputFeedback').on('keyup', function () {
    if ($(this).val().length < 21) {
      $(this).addClass('invalid');
    } else {
      $(this).removeClass('invalid');
    }
  });

  $('#add_send_red').on('click', function (e) {
    e.preventDefault();

    document.location = $(this).data('url');
  });
  $('#add_send').on('click', function (e) {
    e.preventDefault();
    let input = $('#inputFeedback').val();

    if (input.length < 21) {
      $('#inputFeedback').addClass('invalid');
      return false;
    }

    $.ajax({
      url: '/api/feedback/front/send',             // указываем URL и
      method: "POST",
      dataType: "json",
      data: {
        comment: input
      },
      success: function (data, textStatus) { // вешаем свой обработчик на функцию success
        if (data.success) {
          $('#inputFeedback').removeClass('invalid');
          $('#inputFeedback').val('');
          $(".feedback_message_popup").fadeIn();
        }
      }
    });
  });



  $('.questions_blocks .block').on('click', function () {
    if ($(this).hasClass('active-faq')) {
      $('.questions_blocks .block').removeClass(['active', 'active-faq']);
    } else {
      $('.questions_blocks .block').removeClass(['active', 'active-faq']);
      $(this).addClass(['active', 'active-faq']);
    }
  });

  $('.menu_icons').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.right_part').removeClass('active');
    } else {
      $(this).addClass('active');
      $('.right_part').addClass('active');
    }

  });

  if($('.faq').length){
    let url = window.location;
    $(url.hash).click();
    $(".scroll-div").mCustomScrollbar("scrollTo", $(url.hash).position().top , {
      timeout: 0,
      scrollInertia: 400,
    });
  }

});


function resumeSlide(time = 3000) {
  let images = document.getElementsByClassName("container_head_cv")[0]
    .children;
  let mobImages = document.getElementsByClassName(
    "container_head_cv_mob"
  )[0].children;
  if (images.length) {
    let slide = false;
    setInterval(() => {
      var responsiveImages = images;
      if (window.innerWidth < 501) {
        responsiveImages = mobImages;
      }
      for (let i = 0; i < responsiveImages.length; i++) {
        if (responsiveImages[i].classList.contains("active")) {
          responsiveImages[i].classList.remove("active");
          slide = true;
          if (i == responsiveImages.length - 1 && slide) {
            responsiveImages[0].classList.add("active");
          }
          continue;
        }
        if (slide) {
          responsiveImages[i].classList.add("active");
          slide = false;
        }
      }
    }, time);
  }
}


function owlCarusel(resize = false) {
  this.owl = window.innerWidth < 768;
  if (this.owl && !resize) {
    this.owlImages = true;
    this.owl = false;
    setTimeout(() => {
      this.owl = true;
    }, 400);
  }
}

if (window.innerWidth < 501){
  let bestsellers_blocks = $("section.bestsellers .bestsellers_block .all_block_add .blocks");
  bestsellers_blocks.owlCarousel({
    margin : 10 ,
    stagePadding: 20,
    items : 3 ,
    loop:true,
    nav:false,
    dots:true,
    responsive : {
      0 : {
        items : 1,
      } ,
      500 : {
        items : 2,
      } ,
      768 : {
        items : 3,
      } ,
    }
  });
  bestsellers_blocks.addClass('owl-loaded owl-drag owl-carousel owl-theme')
}




// WEBPACK FOOTER //
// ./resources/js/scripts.js